import loginModule from './loginModule' //登录注册
import mainModule from './mainModule'
import uploadModule from './uploadModule'   // 可以用上传
import payModule from './payModule'     // 支付模块

const requestApi = {
    loginModule: loginModule,
    mainModule: mainModule,
    uploadModule: uploadModule,
    payModule: payModule
}

export default requestApi